import { compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { importsClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation InsertImport($input: ImportInput) {
    insertImport(input: $input) {
      id
    }
  }
`

const cleanRequest = compose(pick(['inputDocumentId', 'entity']))

export const useSaveImport = onSave => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Imports'], client: importsClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        onSave(resp.data?.insertImport || {})
      }
    })
  }

  return [handleRequest, state]
}
